import { render, staticRenderFns } from "./CommunicationUser.vue?vue&type=template&id=8ac0283c";
import script from "./CommunicationUser.vue?vue&type=script&lang=js";
export * from "./CommunicationUser.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;